import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const PAS = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14928)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#F4F4F4"
          />
          <rect
            x="81.75"
            y="29.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M138.938 30.2857L82.2858 108.457C82.2858 108.457 82.6837 110.595 83.392 111.366C84.1002 112.138 85.0609 112.571 86.0626 112.571H138.938C139.939 112.571 140.9 112.138 141.608 111.366C142.316 110.595 142.714 109.548 142.714 108.457V34.4C142.714 33.3088 142.316 32.2623 141.608 31.4908C140.9 30.7192 138.938 30.2857 138.938 30.2857Z"
            fill="#E3E3E3"
          />
          <path
            d="M95.1428 48.2856H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 55.9999H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 63.7142H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 71.4285H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 79.1428H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 86.8571H128.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.1428 94.5714H120.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="81.75"
            y="29.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M164.404 74.6141L161.998 77.0195L153.981 69.0016L156.386 66.5962C157.455 65.5613 158.888 64.9881 160.376 65.0002C161.864 65.0123 163.287 65.6087 164.339 66.6608C165.391 67.7129 165.988 69.1364 166 70.6242C166.012 72.1121 165.439 73.5451 164.404 74.6141Z"
            fill="#FF808C"
          />
          <path
            d="M145.225 93.7928L134 97L137.207 85.7749L145.225 93.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M153.981 69.0048L137.207 85.7783L145.225 93.7962L161.999 77.0227L153.981 69.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M164.404 74.6141L161.998 77.0195L153.981 69.0016L156.386 66.5962C157.455 65.5613 158.888 64.9881 160.376 65.0002C161.864 65.0123 163.287 65.6087 164.339 66.6608C165.391 67.7129 165.988 69.1364 166 70.6242C166.012 72.1121 165.439 73.5451 164.404 74.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M145.225 93.7928L134 97L137.207 85.7749L145.225 93.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.981 69.0048L137.207 85.7783L145.225 93.7962L161.999 77.0227L153.981 69.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M209.775 19.9316H206.152V17.6465H209.775C210.335 17.6465 210.791 17.5553 211.143 17.373C211.494 17.1842 211.751 16.9238 211.914 16.5918C212.077 16.2598 212.158 15.8854 212.158 15.4688C212.158 15.0456 212.077 14.6517 211.914 14.2871C211.751 13.9225 211.494 13.6296 211.143 13.4082C210.791 13.1868 210.335 13.0762 209.775 13.0762H207.168V25H204.238V10.7812H209.775C210.889 10.7812 211.842 10.9831 212.637 11.3867C213.438 11.7839 214.049 12.334 214.473 13.0371C214.896 13.7402 215.107 14.5443 215.107 15.4492C215.107 16.3672 214.896 17.1615 214.473 17.832C214.049 18.5026 213.438 19.0202 212.637 19.3848C211.842 19.7493 210.889 19.9316 209.775 19.9316ZM221.289 13.2129L217.422 25H214.307L219.59 10.7812H221.572L221.289 13.2129ZM224.502 25L220.625 13.2129L220.312 10.7812H222.314L227.627 25H224.502ZM224.326 19.707V22.002H216.816V19.707H224.326ZM236.348 21.2793C236.348 21.0254 236.309 20.7975 236.23 20.5957C236.159 20.3874 236.022 20.1986 235.82 20.0293C235.618 19.8535 235.335 19.681 234.971 19.5117C234.606 19.3424 234.134 19.1667 233.555 18.9844C232.91 18.776 232.298 18.5417 231.719 18.2812C231.146 18.0208 230.638 17.7181 230.195 17.373C229.759 17.0215 229.414 16.6146 229.16 16.1523C228.913 15.6901 228.789 15.153 228.789 14.541C228.789 13.9486 228.919 13.4115 229.18 12.9297C229.44 12.4414 229.805 12.0247 230.273 11.6797C230.742 11.3281 231.296 11.0579 231.934 10.8691C232.578 10.6803 233.285 10.5859 234.053 10.5859C235.101 10.5859 236.016 10.7747 236.797 11.1523C237.578 11.5299 238.184 12.0475 238.613 12.7051C239.049 13.3626 239.268 14.1146 239.268 14.9609H236.357C236.357 14.5443 236.27 14.1797 236.094 13.8672C235.924 13.5482 235.664 13.2975 235.312 13.1152C234.967 12.9329 234.531 12.8418 234.004 12.8418C233.496 12.8418 233.073 12.9199 232.734 13.0762C232.396 13.2259 232.142 13.431 231.973 13.6914C231.803 13.9453 231.719 14.2318 231.719 14.5508C231.719 14.7917 231.777 15.0098 231.895 15.2051C232.018 15.4004 232.201 15.5827 232.441 15.752C232.682 15.9212 232.979 16.0807 233.33 16.2305C233.682 16.3802 234.089 16.5267 234.551 16.6699C235.326 16.9043 236.006 17.168 236.592 17.4609C237.184 17.7539 237.679 18.0827 238.076 18.4473C238.473 18.8118 238.773 19.2253 238.975 19.6875C239.176 20.1497 239.277 20.6738 239.277 21.2598C239.277 21.8783 239.157 22.4316 238.916 22.9199C238.675 23.4082 238.327 23.8216 237.871 24.1602C237.415 24.4987 236.872 24.7559 236.24 24.9316C235.609 25.1074 234.902 25.1953 234.121 25.1953C233.418 25.1953 232.725 25.1042 232.041 24.9219C231.357 24.7331 230.736 24.4499 230.176 24.0723C229.622 23.6947 229.18 23.2129 228.848 22.627C228.516 22.041 228.35 21.3477 228.35 20.5469H231.289C231.289 20.9896 231.357 21.3639 231.494 21.6699C231.631 21.9759 231.823 22.2233 232.07 22.4121C232.324 22.6009 232.624 22.7376 232.969 22.8223C233.32 22.9069 233.704 22.9492 234.121 22.9492C234.629 22.9492 235.046 22.8776 235.371 22.7344C235.703 22.5911 235.947 22.3926 236.104 22.1387C236.266 21.8848 236.348 21.5983 236.348 21.2793Z"
            fill="#626266"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14928">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
